import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, shareReplay } from 'rxjs';

import { OidcConfig } from '@common/types';

@Injectable({
  providedIn: 'root',
})
export class AuthDataService {
  private httpClient = inject(HttpClient);
  private authData$: Observable<OidcConfig> | null = null;

  getAuthData(): Observable<OidcConfig> {
    if (!this.authData$) {
      this.authData$ = this.httpClient.get<OidcConfig>('/api/auth').pipe(
        shareReplay(1), // Cache the result and share it across subscribers
      );
    }
    return this.authData$;
  }
}
